export class BuildInfo {
  frontendVersion = '';
  frontendTimestamp = '';
  backendVersion = '';
  backendTimestamp = '';
  appPackageVersion = '';
  configPackageVersion = '';
  deploymentTime = '';
}
